import {
  useConnectionQualityIndicator,
  useParticipants,
} from "@livekit/components-react";
import type { Peer } from "@circle-react/types/Live/Peer";
import type { ProviderPeerSignal } from "../types";
import { CONNECTION_QUALITY } from "./constants";
import { useLivekitLocalParticipant } from "./useLivekitLocalParticipant";

export const useLivekitPeerSignal = (
  peer: Pick<Peer, "id">,
): ProviderPeerSignal => {
  const localParticipant = useLivekitLocalParticipant();
  const participants = useParticipants();
  const { quality } = useConnectionQualityIndicator({
    participant:
      participants.find(p => p.identity === peer.id) || localParticipant,
  });
  return {
    peerDownlinkQuality: CONNECTION_QUALITY[quality],
  };
};
